import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconDashboardComponent } from './svg/icon-dashboard';
import { IconBellBingComponent } from './svg/icon-bell-bing';
import { IconMenuComponent } from './svg/icon-menu';
import { IconInfoCircleComponent } from './svg/icon-info-circle';
import { IconXCircleComponent } from './svg/icon-x-circle';
import { IconCaretsDownComponent } from './svg/icon-carets-down';
import { IconUserComponent } from './svg/icon-user';
import { IconLockDotsComponent } from './svg/icon-lock-dots';
import { IconLogoutComponent } from './svg/icon-logout';

@NgModule({
    imports: [CommonModule],
    declarations: [
        IconDashboardComponent,
        IconBellBingComponent,
        IconMenuComponent,
        IconInfoCircleComponent,
        IconXCircleComponent,
        IconCaretsDownComponent,
        IconUserComponent,
        IconLockDotsComponent,
        IconLogoutComponent
    ],
    exports: [
        IconDashboardComponent,
        IconBellBingComponent,
        IconMenuComponent,
        IconInfoCircleComponent,
        IconXCircleComponent,
        IconCaretsDownComponent,
        IconUserComponent,
        IconLockDotsComponent,
        IconLogoutComponent
    ],
})
export class IconModule {}
